import React, { memo } from 'react';
import { useWindowDimensions } from 'react-native';

import { LoadingSkeleton } from '@/components/SkeletonLoader';
import { Box } from '@/components/lib/components';
import { ds } from '@/components/lib/design.system';
import { useResponsiveColumnCount } from '@/feature/responsive-design/hooks/use-responsive-column-count';
import { common, designSystem } from '@/styles/styles';

import { COLUMN_COUNT, COLUMN_GAP } from './BetList';

const SKELETON_CARD_HEIGHT = 198;

export const BetCardSkeleton = memo(() => {
    return (
        <Box
            height={SKELETON_CARD_HEIGHT}
            backgroundColor={ds.colorToken.background.neutral.subtler}
            borderRadius="r16"
            overflow="hidden"
        >
            <LoadingSkeleton
                skeletonColor={designSystem.colors.neutral300}
                height={SKELETON_CARD_HEIGHT}
                borderRadius="r16"
            />
        </Box>
    );
});

export const BetListSkeleton = memo(() => {
    const { width } = useWindowDimensions();
    const columnCount = useResponsiveColumnCount(COLUMN_COUNT);

    // Calculate card width based on screen width, padding, and column count
    const horizontalPadding = common.paddingHorizontal.paddingHorizontal * 2; // 16px on each side
    const columnGap = columnCount > 1 ? COLUMN_GAP : 0;
    const totalGaps = (columnCount - 1) * columnGap;
    const cardWidth = (width - horizontalPadding - totalGaps) / columnCount;

    const skeletonItems = Array.from({ length: 6 }, (_, index) => index);

    return (
        <Box paddingHorizontal="s16">
            {skeletonItems.map(item => (
                <Box
                    key={item}
                    mt="s16"
                    flex={columnCount > 1 ? undefined : 1}
                    width={columnCount > 1 ? cardWidth : undefined}
                >
                    <BetCardSkeleton />
                </Box>
            ))}
        </Box>
    );
});
